module.exports = __webpack_public_path__ + "img/investors-1-min.4103c52b.png";